import { defineStore } from 'pinia'

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {},
    tokenInfo: {},
    isLoggedIn: false
  }),
  actions: {
    SetUserInfo(data) {
      this.userInfo = data
      // localStorage.setItem('userInfo', JSON.stringify(data));
    },
    SetTokenInfo(data) {
      this.tokenInfo = data
      // localStorage.setItem('userInfo', JSON.stringify(data));
    },
    SetIsLoggedIn(data) {
      this.isLoggedIn = data
      // localStorage.setItem('isLoggedIn', data);
    },
    logout() {
      this.userInfo = {};
      this.tokenInfo = {};
      this.isLoggedIn = false;
      // localStorage.removeItem('userInfo');
      // localStorage.removeItem('isLoggedIn');
    },
    // initializeStore() {
    //   console.log(this.userInfo);
    //   console.log(this.userInfo);
    //   console.log(this.userInfo);
    //   const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    //   const isLoggedIn = localStorage.getItem('isLoggedIn');
    //   if (userInfo) {
    //     this.userInfo = userInfo;
    //   }
    //   if (isLoggedIn) {
    //     this.isLoggedIn = isLoggedIn;
    //   }
    // }
  }
  , persist: {
    enabled: true // true 表示开启持久化保存
  }
})
export const useTableDataStore = defineStore('tableData', {
  state: () => ({
    datas: {},
    values: ''
  }),
  actions: {
    SetDatas(data) {
      this.datas = data
    },
    SetValues(data) {
      this.values = data
    },
  }
})